import { createSelector } from 'reselect';
import { AppStateType } from '../types';
import {
  decodedUserCountrySelector,
  getIsUserLoggedInSelector,
} from '../auth/selectors';
import { defaultCountry, defaultLanguage, defaultLocale } from './constants';

export const intlSelector = (state: AppStateType) => {
  return state.intl;
};

export const localeSelector = createSelector(
  intlSelector,
  (intl) => intl.locale ?? defaultLocale,
);

export const backendLocaleSelector = createSelector(localeSelector, (locale) =>
  locale.replace('_', '-').toUpperCase(),
);

export const countrySelector = createSelector(
  intlSelector,
  getIsUserLoggedInSelector,
  decodedUserCountrySelector,
  (intl, isLoggedIn, authCountry) =>
    (isLoggedIn && authCountry ? authCountry : intl.country) ?? defaultCountry,
);

export const languageSelector = createSelector(
  intlSelector,
  (intl) => intl.language ?? defaultLanguage,
);
